import { usePostJson } from "../hooks/usePostJson";
import Loading from "../tabs/loading";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";

export default function UpdateDriver({driverData, geo}){
    //const navigate = useNavigate();
    const defined = (v) => v !== undefined && v !== null && v !== "";

    console.log(JSON.stringify(driverData));

    const cleanDate = (d) => {
        if(d === undefined){
            return;
        }
        if(d.includes("-")){
            return d.replace(/-/g, ""); 
        }
    }

    const convertDate = (d) =>{
        if (!defined(d)) return undefined;
        // If already "YYYYMMDD", return as-is:
        if (typeof d === "string" && /^\d{8}$/.test(d)) return d;
        try {
            const dt = new Date(d);
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, "0");
            const day = String(dt.getDate()).padStart(2, "0");
            return `${y}${m}${day}`;
        } catch {
            return undefined;
        }
};

    let sex = "1";
    if(driverData.sex === "Not Specified"){
        sex = "9";
    }

    const driverObj = {
    "Header": {
        "Metadata": {
            "UserID": driverData.email  // to replaced with db username
        }
    },
    "Body": {
        "Source":{
            "DataSource": driverData.source,
        },
        "PersonDetails": {
            "PersonName": {
                "SurName": driverData?.surName || "",
                "FirstName": driverData.firstName || "",
                "MiddleName": driverData?.middleName || "",
                "Suffix": driverData?.suffix || ""
            },
            "PhysicalDetails": {
                "Sex": sex
            },
            "DOB" : cleanDate(driverData?.dob) || "",
            "MailingAddress": {
                "Line1": driverData?.street1 ||  "",
                "Line2": driverData?.street2 || "",
                "City": driverData?.city || "",
                "State": geo.S || "",
                "Zip": driverData?.zip || "",
                "County": driverData?.county|| "",
                "Country": geo?.C || ""
            }
        },
        "License": {
            "JurisdictionOfIssue": driverData.driverState,
            "LicenseNumber": driverData.driverLicense
        }
    }
}
    
    console.log("Driver Update: "+JSON.stringify(driverObj))
    //alert("Driver Update: "+JSON.stringify(driverObj))

    const url = "/api/driver/update" 
    const res = usePostJson(url, driverObj, "POST");

    while(res.loading){
        return(<Loading />);
    }

    //alert(JSON.stringify(res))
  
/*
    const direct = "/driverdetails/" ;
        navigate(direct+`${driverData.driverState}/${driverData.riverLicense}`);
*/
    let direct = "/driverdetails/"
        + driverData.driverState + "/" + encodeURIComponent(driverData.driverLicense);
        window.location.replace(direct);



    return(
        <div>
            <h1>Saved</h1>
            <li>{JSON.stringify(res)}</li>
        </div>
    )

}